<template>
  <div
    class="border-2 rounded-md p-px pl-1 min-w-max md:min-w-[170px] w-max max-w-fit flex-y-center justify-center flex-shrink-0"
    :class="checkPct"
  >
    <span class="icon-warning1 text-base mr-auto" :class="statusColor" />
    <span class="mx-auto text-sm md:text-base" v-if="pct && abs">
      {{ formatMoneyExact(pct, 2) }}% ({{ formatMoneyExact(abs, 3) }})
    </span>
    <span class="mx-auto" v-else>0</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { formatMoneyExact } from "@/utils";

interface Props {
  pct: string | number;
  abs: string | number;
}
const props = defineProps<Props>();

const checkPct = computed(() => {
  return props?.pct < 0 ? "border-red" : "border-green";
});
const statusColor = computed(() => {
  return props?.pct < 0 ? "text-red rotate-180" : "text-green";
});
</script>

<style scoped></style>
